/**
 * PerplayAdminApi
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 *
 */

import ApiClient from '../ApiClient';

/**
 * The CommunityControllerDtoPostListRequest model module.
 * @module model/CommunityControllerDtoPostListRequest
 * @version 1.0
 */
class CommunityControllerDtoPostListRequest {
    /**
     * Constructs a new <code>CommunityControllerDtoPostListRequest</code>.
     * @alias module:model/CommunityControllerDtoPostListRequest
     * @param page {Number} 
     * @param pageLength {Number} 
     * @param postType {Number} 
     * @param attachedPer {Boolean} 
     * @param attachedXper {Boolean} 
     * @param isAttachedItem {Boolean} 
     */
    constructor(page, pageLength, postType, attachedPer, attachedXper, isAttachedItem) { 
        
        CommunityControllerDtoPostListRequest.initialize(this, page, pageLength, postType, attachedPer, attachedXper, isAttachedItem);
    }

    /**
     * Initializes the fields of this object.
     * This method is used by the constructors of any subclasses, in order to implement multiple inheritance (mix-ins).
     * Only for internal use.
     */
    static initialize(obj, page, pageLength, postType, attachedPer, attachedXper, isAttachedItem) { 
        obj['page'] = page;
        obj['pageLength'] = pageLength;
        obj['postType'] = postType;
        obj['attachedPer'] = attachedPer;
        obj['attachedXper'] = attachedXper;
        obj['isAttachedItem'] = isAttachedItem;
    }

    /**
     * Constructs a <code>CommunityControllerDtoPostListRequest</code> from a plain JavaScript object, optionally creating a new instance.
     * Copies all relevant properties from <code>data</code> to <code>obj</code> if supplied or a new instance if not.
     * @param {Object} data The plain JavaScript object bearing properties of interest.
     * @param {module:model/CommunityControllerDtoPostListRequest} obj Optional instance to populate.
     * @return {module:model/CommunityControllerDtoPostListRequest} The populated <code>CommunityControllerDtoPostListRequest</code> instance.
     */
    static constructFromObject(data, obj) {
        if (data) {
            obj = obj || new CommunityControllerDtoPostListRequest();

            if (data.hasOwnProperty('page')) {
                obj['page'] = ApiClient.convertToType(data['page'], 'Number');
            }
            if (data.hasOwnProperty('pageLength')) {
                obj['pageLength'] = ApiClient.convertToType(data['pageLength'], 'Number');
            }
            if (data.hasOwnProperty('skip')) {
                obj['skip'] = ApiClient.convertToType(data['skip'], 'Number');
            }
            if (data.hasOwnProperty('postType')) {
                obj['postType'] = ApiClient.convertToType(data['postType'], 'Number');
            }
            if (data.hasOwnProperty('attachedPer')) {
                obj['attachedPer'] = ApiClient.convertToType(data['attachedPer'], 'Boolean');
            }
            if (data.hasOwnProperty('attachedXper')) {
                obj['attachedXper'] = ApiClient.convertToType(data['attachedXper'], 'Boolean');
            }
            if (data.hasOwnProperty('isAttachedItem')) {
                obj['isAttachedItem'] = ApiClient.convertToType(data['isAttachedItem'], 'Boolean');
            }
            if (data.hasOwnProperty('attachedItem')) {
                obj['attachedItem'] = ApiClient.convertToType(data['attachedItem'], ['Number']);
            }
            if (data.hasOwnProperty('sentAt')) {
                obj['sentAt'] = ApiClient.convertToType(data['sentAt'], 'String');
            }
            if (data.hasOwnProperty('expireAt')) {
                obj['expireAt'] = ApiClient.convertToType(data['expireAt'], 'String');
            }
            if (data.hasOwnProperty('searchString')) {
                obj['searchString'] = ApiClient.convertToType(data['searchString'], 'String');
            }
            if (data.hasOwnProperty('itemName')) {
                obj['itemName'] = ApiClient.convertToType(data['itemName'], 'String');
            }
            if (data.hasOwnProperty('postNo')) {
                obj['postNo'] = ApiClient.convertToType(data['postNo'], 'Number');
            }
            if (data.hasOwnProperty('accountNo')) {
                obj['accountNo'] = ApiClient.convertToType(data['accountNo'], 'Number');
            }
        }
        return obj;
    }

    /**
     * Validates the JSON data with respect to <code>CommunityControllerDtoPostListRequest</code>.
     * @param {Object} data The plain JavaScript object bearing properties of interest.
     * @return {boolean} to indicate whether the JSON data is valid with respect to <code>CommunityControllerDtoPostListRequest</code>.
     */
    static validateJSON(data) {
        // check to make sure all required properties are present in the JSON string
        for (const property of CommunityControllerDtoPostListRequest.RequiredProperties) {
            if (!data[property]) {
                throw new Error("The required field `" + property + "` is not found in the JSON data: " + JSON.stringify(data));
            }
        }
        // ensure the json data is an array
        if (!Array.isArray(data['attachedItem'])) {
            throw new Error("Expected the field `attachedItem` to be an array in the JSON data but got " + data['attachedItem']);
        }
        // ensure the json data is a string
        if (data['sentAt'] && !(typeof data['sentAt'] === 'string' || data['sentAt'] instanceof String)) {
            throw new Error("Expected the field `sentAt` to be a primitive type in the JSON string but got " + data['sentAt']);
        }
        // ensure the json data is a string
        if (data['expireAt'] && !(typeof data['expireAt'] === 'string' || data['expireAt'] instanceof String)) {
            throw new Error("Expected the field `expireAt` to be a primitive type in the JSON string but got " + data['expireAt']);
        }
        // ensure the json data is a string
        if (data['searchString'] && !(typeof data['searchString'] === 'string' || data['searchString'] instanceof String)) {
            throw new Error("Expected the field `searchString` to be a primitive type in the JSON string but got " + data['searchString']);
        }
        // ensure the json data is a string
        if (data['itemName'] && !(typeof data['itemName'] === 'string' || data['itemName'] instanceof String)) {
            throw new Error("Expected the field `itemName` to be a primitive type in the JSON string but got " + data['itemName']);
        }

        return true;
    }


}

CommunityControllerDtoPostListRequest.RequiredProperties = ["page", "pageLength", "postType", "attachedPer", "attachedXper", "isAttachedItem"];

/**
 * @member {Number} page
 */
CommunityControllerDtoPostListRequest.prototype['page'] = undefined;

/**
 * @member {Number} pageLength
 */
CommunityControllerDtoPostListRequest.prototype['pageLength'] = undefined;

/**
 * @member {Number} skip
 */
CommunityControllerDtoPostListRequest.prototype['skip'] = undefined;

/**
 * @member {Number} postType
 */
CommunityControllerDtoPostListRequest.prototype['postType'] = undefined;

/**
 * @member {Boolean} attachedPer
 */
CommunityControllerDtoPostListRequest.prototype['attachedPer'] = undefined;

/**
 * @member {Boolean} attachedXper
 */
CommunityControllerDtoPostListRequest.prototype['attachedXper'] = undefined;

/**
 * @member {Boolean} isAttachedItem
 */
CommunityControllerDtoPostListRequest.prototype['isAttachedItem'] = undefined;

/**
 * @member {Array.<Number>} attachedItem
 */
CommunityControllerDtoPostListRequest.prototype['attachedItem'] = undefined;

/**
 * @member {String} sentAt
 */
CommunityControllerDtoPostListRequest.prototype['sentAt'] = undefined;

/**
 * @member {String} expireAt
 */
CommunityControllerDtoPostListRequest.prototype['expireAt'] = undefined;

/**
 * @member {String} searchString
 */
CommunityControllerDtoPostListRequest.prototype['searchString'] = undefined;

/**
 * @member {String} itemName
 */
CommunityControllerDtoPostListRequest.prototype['itemName'] = undefined;

/**
 * @member {Number} postNo
 */
CommunityControllerDtoPostListRequest.prototype['postNo'] = undefined;

/**
 * @member {Number} accountNo
 */
CommunityControllerDtoPostListRequest.prototype['accountNo'] = undefined;






export default CommunityControllerDtoPostListRequest;

